/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Key_Admin_Audit_ViewInputs */

const cs_audit_key_admin_audit_view = /** @type {(inputs: Audit_Key_Admin_Audit_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Administrátor zobrazil auditní log`)
};

const en_audit_key_admin_audit_view = /** @type {(inputs: Audit_Key_Admin_Audit_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Admin viewed audit log`)
};

/**
* | output |
* | --- |
* | "Admin viewed audit log" |
*
* @param {Audit_Key_Admin_Audit_ViewInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const audit_key_admin_audit_view = /** @type {((inputs?: Audit_Key_Admin_Audit_ViewInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Key_Admin_Audit_ViewInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_audit_key_admin_audit_view(inputs)
	return cs_audit_key_admin_audit_view(inputs)
});